import { createSlice } from "@reduxjs/toolkit";

interface UserState {
  theme: null | any;
}

const initialState: UserState = {
  theme: {
    isDarkMode: false,
  },
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    storeTheme: (state, action) => {
      state.theme.isDarkMode = action.payload;
    },
  },
});

export const { storeTheme } = themeSlice.actions;

export default themeSlice.reducer;
